import { Dispatch, SetStateAction, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { formatUSD } from '../../helpers/helperFunctions';
import { CaptionText, P1, P3 } from '../../styles/FontStyles';
import { color } from '../../styles/GlobalStyles';
import { TokenInfo } from './Airdrop.types';
import { AirdropHeaderItem, BlurredValue } from './AirdropsStyled';
import { Link } from 'react-router-dom';
import { Button, SidebarModal } from '../../components';
import { SETTINGS_VIRTUAL_OFFICE } from '../../routes/routes';
import {
  Icon,
  IconLock,
  IconTokenTelegram,
  IconTwitter,
  IconWebsite,
  InfoSmallIcon
} from '../../styles/Icons';

import Countdown from 'react-countdown';

import dexscreener from '../../assets/images/backoffice/airDrop/dexscreener.png';
import { Flex } from '../../styles/stylesStyled';
import { Flexed } from '../../styles/GlobalComponents';
import moment from 'moment';
import { KimbaDetailsHeaderDesktop } from './KimbaDetailsHeaderDesktop';
import { KimbaDetailsItem } from './KimbaDetailsItem';

interface AirdropItemProps {
  airdrop: TokenInfo;
  licence: boolean;
  key: number;
}

export const AirdropItem = ({ airdrop, licence, key }: AirdropItemProps) => {
  const [openModal, setOpenModal] = useState(false);
  const formatterCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    unitDisplay: 'short',
    // These options are needed to round to whole numbers if that's what you want.
    minimumFractionDigits: 7 // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  return (
    <>
      <AirdropHeaderItem style={{ alignItems: 'center' }}>
        <Flexed center>
          <img
            src={airdrop.image}
            alt='token'
            style={{ width: '40px', marginRight: 10 }}
          />
          {airdrop.name}
        </Flexed>
      </AirdropHeaderItem>

      <AirdropHeaderItem
        data-tip
        data-for={'airdrop-tooltip-licence' + key}
        onClick={() => {
          licence && setOpenModal(!openModal);
        }}
        style={{ cursor: licence ? 'pointer' : 'default' }}>
        <BlurredValue blurred={licence}>
          {airdrop.tokenAmount !== '/'
            ? formatUSD(Number(airdrop.tokenAmount))
            : '/'}
        </BlurredValue>

        {!licence && (
          <P1 mt='8' color={color.colors.primary900}>
            View Tokens
          </P1>
        )}
      </AirdropHeaderItem>

      <AirdropHeaderItem
        onClick={() => {
          licence && setOpenModal(!openModal);
        }}
        style={{ cursor: licence ? 'pointer' : 'default' }}>
        <InfoSmallIcon disabled={false} />
      </AirdropHeaderItem>

      <AirdropHeaderItem>
        {airdrop.price !== '/'
          ? formatterCurrency.format(Number(airdrop.price))
          : '/'}
      </AirdropHeaderItem>

      <AirdropHeaderItem>
        {airdrop.totalValue !== '/'
          ? formatterCurrency.format(Number(airdrop.totalValue))
          : '/'}
      </AirdropHeaderItem>
      {airdrop.tokenId === 1 && (
        <AirdropHeaderItem disabled>
          {/* <a href={`https://hakunamatata.meme`} target='_blank' rel='noreferrer'> */}
          <Icon>
            <IconWebsite />
          </Icon>
          {/* </a> */}
        </AirdropHeaderItem>
      )}

      {airdrop.tokenId === 2 && (
        <AirdropHeaderItem>
          <a href={`https://vodkacoin.meme`} target='_blank' rel='noreferrer'>
            <Icon>
              <IconWebsite />
            </Icon>
          </a>
        </AirdropHeaderItem>
      )}
      {airdrop.tokenId === 1 && (
        <AirdropHeaderItem>
          <a href={`https://x.com/kimba_meme`} target='_blank' rel='noreferrer'>
            <Icon>
              <IconTwitter />
            </Icon>
          </a>
        </AirdropHeaderItem>
      )}

      {airdrop.tokenId === 2 && (
        <AirdropHeaderItem>
          <a
            href={`https://x.com/Vodkacoinreal`}
            target='_blank'
            rel='noreferrer'>
            <Icon>
              <IconTwitter />
            </Icon>
          </a>
        </AirdropHeaderItem>
      )}

      {airdrop.tokenId === 1 && (
        <AirdropHeaderItem>
          <a
            href={`https://t.me/KIMBA_THE_WHITE_LION_official`}
            target='_blank'
            rel='noreferrer'>
            <Icon>
              <IconTokenTelegram />
            </Icon>
          </a>
        </AirdropHeaderItem>
      )}

      {airdrop.tokenId === 2 && (
        <AirdropHeaderItem disabled>
          <Icon>
            <IconTokenTelegram />
          </Icon>
        </AirdropHeaderItem>
      )}

      {airdrop.tokenId === 1 && (
        <AirdropHeaderItem>
          <a
            href={`https://www.dextools.io/app/en/token/kimba?t=1733224330154`}
            target='_blank'
            rel='noreferrer'>
            <img src={dexscreener} style={{ width: 43 }} />
          </a>
        </AirdropHeaderItem>
      )}

      {airdrop.tokenId === 2 && (
        <AirdropHeaderItem>
          <a
            href={`https://dexscreener.com/solana/eswmjdqd4qp3kfxslwn1apcuuyytgrbcfmjhy2flkzrv`}
            target='_blank'
            rel='noreferrer'>
            <img src={dexscreener} style={{ width: 43 }} />
          </a>
        </AirdropHeaderItem>
      )}

      {!licence && (
        <ReactTooltip
          clickable
          id={'airdrop-tooltip-licence' + key}
          place='top'
          effect='solid'
          backgroundColor='#fff'
          delayHide={200}>
          <div style={{ width: 200 }}>
            <CaptionText color={color.colors.neutral500} semiBold mb='8'>
              To unlock your accumulated tokens you need to have a paid
              Back-Office subscription.
            </CaptionText>
            <Link to={SETTINGS_VIRTUAL_OFFICE}>
              <Button>Get BO Subscription</Button>
            </Link>
          </div>
        </ReactTooltip>
      )}

      <SidebarModal
        isOpen={openModal}
        setOpen={setOpenModal}
        title={`KIMBA Airdrops Details`}
        sidebarWidth={'600px'}>
        <div>
          <KimbaDetailsHeaderDesktop />
          {airdrop?.airdrops?.map((airdropItem, index) => {
            return (
              <div key={index}>
                <KimbaDetailsItem
                  airdrop={airdrop}
                  index={index}
                  airdropItem={airdropItem}
                />
              </div>
            );
          })}
        </div>
      </SidebarModal>
    </>
  );
};
